import React, {useState, useContext, useEffect, useMemo} from "react";
import './FichaTecnicaSubtabla.css';
import RRAtributoFichaTecnica from "./RRAtributoFichaTecnica";
import FormDocumento from "../FormDocumento/FormDocumento.js";
import { createEstructuraDocumento, createEstructuraFichaTecnica, estructuraDocumento } from "../../utils/estructuras.js";

import atributosFichaTecContext from "../../context/atributosFichaTecContext/atributosFichaTecContex.js";
import FormAtributoFichaTecnica from "../FormAtributoFichaTecnica/FormAtributoFichaTecnica.js";


const FichaTecnicaSubtabla = ({fichaTecnica, handleChangeActivo, selectSelect, tablaSeleccionada, modo}) => {

    const [showAdd,setShowAdd] = useState(false);
    const [data,setData] = useState('');
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);

    const {atributosList, actualizarAtributosFichaTecList} = useContext(atributosFichaTecContext);

    const options = useMemo(()=>atributosList.map(a => ({id: a._id, value: a.codAtributo, label: a.name, fecMod: a.fecMod, fecAlt: a.fecAlt})), [atributosList]);

    const handleChange = (e = {}, i, prop='', value=undefined) => {
        let newAtrs = fichaTecnica.slice();
        
        if(prop != '' && value != ''){
            if(prop == 'atributo' && newAtrs[i].atributo.label == '' ) newAtrs.push({...createEstructuraFichaTecnica()});
            newAtrs[i][prop] = value;
        }else{
            let {name,value} = e.target;
            newAtrs[i][name] = value;
        }
        handleChangeActivo({},'fichaTecnica',newAtrs);
    }

    const handleDelete = (doc, index) => {
        let actualDocs = fichaTecnica.slice();
        if(doc.fecha != ''){
            let docsToUpdate = actualDocs.filter((p,i) => i != index);
            handleChangeActivo({},'fichaTecnica',docsToUpdate);                         
        }
    }

    const minimizar = () =>{
        setShowAdd(false);
    }

    useEffect(()=>{
        actualizarAtributosFichaTecList();
    },[])

    return <div className={`${(tablaSeleccionada != 'fichaTecnica') && 'inactive'} fichaTecnicaSubtablaDiv`}>
        <label>Ficha Técnica</label>
        <div className={`headerSubtabla ${(modo != 'Vista') ? 'fiveColumns' : ''}`}>
            {modo != 'Vista' && <label id="deleteLabel"></label>}
            <label>Atributo</label>
            <label>Valor</label>
            <label>Observaciones</label>
        </div>
        <div className="bodyTable">
            {(fichaTecnica != undefined) && fichaTecnica.map((a, i) => <RRAtributoFichaTecnica key={i} index={i} atributo={a} setData={setData} modo={modo} handleChange={handleChange} handleDelete={handleDelete} setShowAdd={setShowAdd} setIndexToUpdate={setIndexToUpdate} setNuevoEditado={setNuevoEditado} optionsAtributos={options}/>)}
        </div>
        {showAdd && <FormAtributoFichaTecnica data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeAtributos={handleChange} index={indexToUpdate}/>}
    </div>

}

export default FichaTecnicaSubtabla;